module.exports = __webpack_public_path__ + "static/media/glossy_click_26.cac38d1e.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/glossy_click_26.wav
// module id = 163
// module chunks = 0